import * as Yup from "yup";
import { VALIDATION_MESSAGES } from ".";

/* Yup validation schema for step4 */
export const getValidationShema = (intl) => {
  const validationShema = Yup.object({
    mainProjectPhoto: Yup.string().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    projectPhotos: Yup.array()
    .of(
      Yup.mixed()
        .test("fileType", "El tipo de archivo no es válido", (value) => {
          const allowedTypes = ["image/jpeg", "image/png"]; // Tipos permitidos
          return value && allowedTypes.includes(value.type);
        })
    )
    .min(1, intl.formatMessage(VALIDATION_MESSAGES.required)), // Requiere al menos un archivo,
    projectImagesPaths: Yup.array(),
    projectPhotosPolicy: Yup.boolean().oneOf([true], intl.formatMessage(VALIDATION_MESSAGES.required)),
  })

  return validationShema;
}
